import Seo from "../components/Seo";
import PublicHeader from "../components/PublicHeader";
import MarketingCta from "../components/MarketingCta";
import Footer from "../components/Footer";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import FAQS from "../data/faqs.json";

const FAQ_JSONLD = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": FAQS.map(({ q, a }) => ({
    "@type": "Question",
    "name": q,
    "acceptedAnswer": { "@type": "Answer", "text": a },
  })),
};

export default function Faq() {
  return (
    <div className="min-h-screen bg-background flex flex-col" data-testid="faq-page">
      <Seo
        title="FAQ | CBAIQ — Collective Agreement AI, Answered"
        description="Frequently asked questions about CBAIQ: how AI interprets collective agreements, answer accuracy, document security, supported formats, union and employer use, and pricing."
        path="/faq"
        jsonLd={FAQ_JSONLD}
      />
      <PublicHeader />

      <div className="flex-1">
        <section className="pt-20 sm:pt-24 pb-10 px-4" data-testid="faq-hero">
          <div className="max-w-3xl mx-auto">
            <p className="text-xs uppercase tracking-widest text-muted-foreground font-medium mb-4">FAQ</p>
            <h1 className="font-heading text-4xl sm:text-5xl font-semibold leading-tight tracking-tight text-foreground mb-5">
              Frequently Asked Questions
            </h1>
            <p className="text-base text-muted-foreground leading-relaxed">
              Everything you need to know about using AI to interpret collective agreements — accuracy,
              security, who CBAIQ is for, and how pricing works.
            </p>
          </div>
        </section>

        <section className="pb-16 px-4" data-testid="faq-list">
          <div className="max-w-3xl mx-auto">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map(({ q, a }, idx) => (
                <AccordionItem key={q} value={`faq-${idx}`} data-testid={`faq-item-${idx}`}>
                  <AccordionTrigger className="text-left text-base font-medium" data-testid={`faq-trigger-${idx}`}>
                    {q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm text-muted-foreground leading-relaxed" data-testid={`faq-content-${idx}`}>
                    {a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </section>

        <MarketingCta
          page="faq"
          heading="Still Have Questions?"
          subtext="Try CBAIQ free with your own agreement, or talk to our team about Organization plans."
        />
      </div>
      <Footer />
    </div>
  );
}
